import { createQuery } from '../api/query'

const keyBillingUsage = (businessId: string) => [`billing`, businessId, `usage`]
const keyBillingLogs = (businessId: string, page: number) => [`billing`, businessId, `logs`, page.toString()]
void keyBillingUsage
void keyBillingLogs

export const useQueryBillingUsage = createQuery<any>({
    key: (arg: string) => [`billing`, `usage`, arg],
    url: '/billing/:businessId/usage',
    options: {
        refetchInterval: 30000, // 30 seconds
        staleTime: 10000, // 10 seconds
    }
})

export const useQueryCreditLogs = createQuery<any>({
    key: (arg: string) => [`billing`, arg, `logs`],
    url: '/billing/:businessId/logs',
})

